
import { baseURL } from '@/api/config'
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { getToken } from "@/utils/auth";

import store from '@/store';
//generateType重新生成：generate；编辑：update
export const fetchSseData = (documentId, pageNum, callBack, Success, lastReply = '', generateType = 'generate') => {
    const controller = new AbortController();
    const signal = controller.signal;
    const token = getToken();
    const encodedlastReply = encodeURIComponent(lastReply);

    let url = '';
    if (baseURL == '/api') {
        url = `http://192.168.50.208:8081/ppt-talk/doc/generateVoiceOver/sse?documentId=${documentId}&pageNum=${pageNum}&generateType=${generateType}&lastReply=${encodedlastReply}`;
    } else {
        url = `${baseURL}/ppt-talk/doc/generateVoiceOver/sse?documentId=${documentId}&pageNum=${pageNum}&generateType=${generateType}&lastReply=${encodedlastReply}`;
    }
    // 创建控制器
    // this.controller = new AbortController();

    fetchEventSource(url, {
        method: 'GET', // SSE 通常使用 GET
        headers: {
            'satoken': token,

        },
        signal: signal, // 用于终止连接
        onopen: () => {
            console.log('SSE connection opened');
        },
        onmessage: (event) => {
            console.log(event.data)
            callBack(event.data)
        },
        onerror: (error) => {
            console.error('SSE error:', error);
            // 如果需要，可以在错误时重试
        },
        onclose: () => {
            console.log('SSE connection closed');
            Success()
        },
    });

    return controller
}



export const fetchSseModifyData = (question, documentId, pageNum, sessionId, callBack, Success, onMessageCallBack, lastReply = '', generateType = 'update') => {
    const controller = new AbortController();
    const signal = controller.signal;
    const token = getToken();

    const encodedValue = encodeURIComponent(question);
    const encodedlastReply = encodeURIComponent(lastReply);

    let url = '';

    if (baseURL == '/api') {
        url = `http://192.168.50.208:8081/ppt-talk/doc/generateVoiceOver/sse?question=${encodedValue}&documentId=${documentId}&pageNum=${pageNum}&sessionId=${sessionId}&generateType=${generateType}&lastReply=${encodedlastReply}`;
    } else {
        url = `${baseURL}/ppt-talk/doc/generateVoiceOver/sse?question=${encodedValue}&documentId=${documentId}&pageNum=${pageNum}&sessionId=${sessionId}&generateType=${generateType}&lastReply=${encodedlastReply}`;
    }
    // 创建控制器
    // this.controller = new AbortController();
    let isOnMessage = false
    fetchEventSource(url, {
        method: 'GET', // SSE 通常使用 GET
        headers: {
            'satoken': token,

        },
        signal: signal, // 用于终止连接
        onopen: () => {
            console.log('SSE connection opened');
            isOnMessage = true
        },
        onmessage: (event) => {
            // console.log(event.data)

            if (isOnMessage) {
                isOnMessage = false
                onMessageCallBack()
            }
            callBack(event.data)
        },
        onerror: (error) => {
            console.error('SSE error:', error);
            // 如果需要，可以在错误时重试
        },
        onclose: () => {
            console.log('SSE connection closed');
            Success()
        },
    });

    return controller
}




export const dialogueSseData = (documentId, pageNum, sessionId, content, callBack, Success) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const token = getToken();

    const encodedcontent = encodeURIComponent(content);
    let url = '';
    if (baseURL == '/api') {
        url = `http://192.168.50.208:8081/ppt-talk/dialogue?documentId=${documentId}&pageNum=${pageNum}&sessionId=${sessionId}&content=${encodedcontent}`;
    } else {
        url = `${baseURL}/ppt-talk/dialogue?documentId=${documentId}&pageNum=${pageNum}&sessionId=${sessionId}&content=${encodedcontent}`;
    }
    // 创建控制器
    // this.controller = new AbortController();

    fetchEventSource(url, {
        method: 'GET', // SSE 通常使用 GET
        headers: {
            'satoken': token,

        },
        signal: signal, // 用于终止连接
        onopen: () => {
            console.log('SSE connection opened');
        },
        onmessage: (event) => {
            console.log(event.data)
            callBack(event.data)
        },
        onerror: (error) => {
            console.error('SSE error:', error);
            // 如果需要，可以在错误时重试
        },
        onclose: () => {
            console.log('SSE connection closed');
            Success()
        },
    });

    return controller
}



export const testTranslation = (params) => {

    return new Promise((resolve, reject) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI2MTI2NDcxOS1lNTJhLTQ5ZDktOWM1MC04MTBjM2Y3ZjFjYTAiLCJzdWIiOiJXZWIgQVBJIFBhc3Nwb3J0IiwiYXBwX2lkIjoiNjEyNjQ3MTktZTUyYS00OWQ5LTljNTAtODEwYzNmN2YxY2EwIiwiYXBwX2NvZGUiOiJhT25DT0hlSU02NnJZQzJqIiwiZW5kX3VzZXJfaWQiOiJhMGYwZDc0ZC02MzFlLTRmYTEtODM2My1kZDBmODM4ODM0MTUifQ.SO_NtEnHAHjMvkGoZo3kuxopQougrr6wVl7HDv4OxzA");
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "*/*");
        myHeaders.append("Host", "35.224.82.168");

        var raw = JSON.stringify({
            "inputs": {
                "source_text": params.content,
                "target_lang": params.languages
            },
            "response_mode": "streaming"
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        // fetch("http://35.224.82.168/api/workflows/run", requestOptions)
        //     .then(response => response.json())
        //     .then(result => console.log(result.data))
        // .catch(error => console.log('error', error));

        fetch("http://35.224.82.168/api/workflows/run", requestOptions)
            .then(response => {
                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let buffer = '';

                function readStream() {
                    return reader.read().then(({ done, value }) => {
                        if (done) {
                            console.log('Stream complete');
                            return;
                        }

                        // 解码流数据
                        const chunk = decoder.decode(value, { stream: true });
                        buffer += chunk;

                        // 解析 SSE 格式的数据
                        const lines = buffer.split('\n');
                        for (let line of lines) {
                            if (line.startsWith('data: ') && line.endsWith('}}')) {
                                const jsonString = line.slice(6); // 去掉 "data: " 前缀
                                try {
                                    console.log('-----', jsonString);
                                    const data = JSON.parse(jsonString);
                                    if (data.event == "workflow_finished") {
                                        resolve({
                                            code: 200,
                                            data: data.data.outputs.text
                                        })
                                    }
                                } catch (error) {
                                    reject()
                                    console.error('Failed to parse JSON:', error);
                                }
                            }
                        }

                        // 继续读取下一块数据
                        return readStream();
                    });
                }

                return readStream();
            })
            .catch(error => {
                reject()
                console.error('Error:', error);
            });

    })
}

const splitByPageNumberWithTrailingSpace = (text, callback) => {
    const regex = /Page \d+ /g;
    const matches = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
        matches.push({ index: match.index, header: match[0] });
    }

    if (matches.length === 0) {
        callback(text);
        return;
    }

    for (let i = 0; i < matches.length; i++) {
        const startIndex = matches[i].index;
        const endIndex = i + 1 < matches.length ? matches[i + 1].index : text.length;
        const chunk = text.slice(startIndex, endIndex);
        callback(chunk);
    }
};

import { UnityAPIURL } from '@/api/config'
import { useToast } from "@/composables/useToast";
const toast = useToast();
export const sseText = async ({ path, data, callBack, end, getTask_id, abortController, getDialogue_bid }) => {
    let url = '';
    if (baseURL == '/api') {
        url = `${UnityAPIURL()}${path}`;
    } else {
        url = `${baseURL}${path}`;
    }

    const token = getToken();
    let response;
    try {
        response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'satoken': token,
            },
            body: JSON.stringify(data),
            signal: abortController && abortController.signal, // 关键
        });
        if (!response.ok) {
            // 这里处理 HTTP 错误（如 500、404）
            console.error('HTTP 错误:', response.status);
            // 你可以手动 throw
            throw new Error('HTTP 错误: ' + response.status);
        }
    } catch (err) {
        if (err.name === 'AbortError') {
            console.log('请求被手动中止');
        } else {
            console.error('请求异常:', err);
        }
        end();
        return;
    }

    const contentType = response.headers.get("Content-Type") || "";

    if (!response.ok) {
        const errorText = await response.text();
        console.error("请求失败:", errorText);
        end();
        return;
    }

    // ✅ 非流式响应：直接处理 JSON 内容
    if (!response.body || !contentType.includes("text/event-stream")) {
        try {
            const json = await response.json();

            if (json.answer) {
                fn(json.answer);
            }
            if (json.code == 10000) {
                store.dispatch("user/set_recharge", {
                    recharge: true,
                    rechargeText:
                        json.msg
                }); //提示充值
                end(true);
            }

        } catch (err) {
            console.error("非流式响应解析失败:", err);
            end();
        }
        return;
    }

    // ✅ SSE 流式响应处理
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let displayText = "";
    let task_id = ''
    let dialogue_bid = ''
    while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop() ?? "";

        for (const line of lines) {
            const trimmed = line.trim();
            if (!trimmed) continue;

            if (trimmed.startsWith("data:data:")) {
                const jsonStr = trimmed.replace(/^data:data:\s*/, "");
                if (jsonStr === "[DONE]") {
                    console.log("流式传输完成");
                    break;
                }

                try {
                    const parsed = JSON.parse(jsonStr);
                    if (parsed.event === 'message') {
                        displayText += parsed?.answer || "";
                        if (parsed?.task_id && !task_id) {
                            task_id = parsed?.task_id
                            getTask_id(task_id)
                        }
                        if (parsed?.dialogueBid && !dialogue_bid) {
                            dialogue_bid = parsed?.dialogueBid
                            getDialogue_bid(dialogue_bid)
                        }
                    }
                    if (parsed.event === 'message_end') {
                        end();
                    }
                    if (parsed.event === 'error') {
                        toast.warning('', { title: parsed.errorMessage });
                    }
                    if (displayText) {
                        callBack(displayText);
                        displayText = '';
                    }
                } catch (err) {
                    console.warn("JSON 解析失败：", jsonStr, err);
                }
            }
        }
    }

    end();
};


export const createPageProcessor = (onPageReady) => {
    let buffer = "";
    let currentPage = null;
    let pageNum = null;
    let lastCallbackLength = 0;

    const pageMarkerPrefix = "%G7VKd2Fkb3JfXw ";
    // 页码后支持旧格式的 %，以及实际流返回的 LF/CRLF 换行。
    const pageRegex = /%G7VKd2Fkb3JfXw (\d+)(?:%|\r?\n)/g;

    // 暂存末尾可能尚未接收完整的分页标记，避免把它作为正文回调。
    function getSafeTextLength() {
        const markerStart = buffer.lastIndexOf("%");
        if (markerStart === -1) return buffer.length;

        const suffix = buffer.slice(markerStart);
        if (pageMarkerPrefix.startsWith(suffix) ||
            (suffix.startsWith(pageMarkerPrefix) &&
                /^\d*\r?$/.test(suffix.slice(pageMarkerPrefix.length)))) {
            return markerStart;
        }
        return buffer.length;
    }

    function handleChunk(chunk) {
        buffer += chunk;

        let match;
        while ((match = pageRegex.exec(buffer)) !== null) {
            pageNum = parseInt(match[1], 10);

            const index = match.index;
            
            if (currentPage !== null) {
                const content = buffer.slice(0, index).trim();
                
                if (content) {
                    console.log(currentPage)
                    onPageReady({
                        page: currentPage,
                        text: content.replace(/%G7VKd2Fkb3JfXw \d+\s*%/g, ""),
                        done: true,
                    });
                }
            }

            currentPage = pageNum;

            buffer = buffer.slice(index + match[0].length);
            pageRegex.lastIndex = 0;
            lastCallbackLength = 0;
        }

        const safeTextLength = getSafeTextLength();
        if (currentPage !== null && safeTextLength > lastCallbackLength) {

            // console.log('slice result:', JSON.stringify(buffer.slice(lastCallbackLength)));
            const newText = buffer
                .slice(lastCallbackLength, safeTextLength)
                .replace(/%G7VKd2Fkb3JfXw \d+\s*%/g, "");
            onPageReady({
                page: currentPage,
                text: newText,
                done: false,
            });
            lastCallbackLength = safeTextLength;
        }
    }

    function flush() {
        if (currentPage !== null && buffer.trim()) {
            onPageReady({
                page: currentPage,
                text: buffer.replace(/%G7VKd2Fkb3JfXw \d+\s*%/g, "").trim(),
                done: true,
            });
        }
        buffer = "";
        currentPage = null;
        lastCallbackLength = 0;
    }

    return {
        handleChunk,
        flush,
    };
};